import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { setCopyData, setData } from "../../../../redux/dataSlice";
import { setActiveHeaderTab } from "../../../../redux/headerTabsSlice";

const HistoryHeaderTabs = () => {
  const activeHeaderTab = useSelector(
    (state) => state.activeHeaderTab.activeHeaderTab
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const headerTabs = [
    { name: "Cylinder History", key: "cylinderHistory" },
    { name: "Vehicle History", key: "vehicleHistory" },
  ];

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const getTabClass = (key) =>
    `header-tab-btn ${
      activeHeaderTab === key ? "bg-lb3 text-dark-blue" : "bg-[#d9d9d95c]"
    }`;

  const handleTabClick = (key, data) => {
    if (activeHeaderTab !== key) {
      dispatch(setActiveHeaderTab(key));
      dispatch(setData(data));
      dispatch(setCopyData(data));
    }
  };

  useEffect(() => {
    dispatch(setActiveHeaderTab("cylinderHistory"));
  }, []);

  return (
    <div className="font-figtree text-white flex items-center">
      <ChevronLeft
        color="white"
        size="30"
        onClick={handleBackButtonClick}
        className="cursor-pointer"
      />
      {headerTabs.map(({ name, key, data }) => (
        <h4
          key={key}
          onClick={() => handleTabClick(key, data)}
          className={getTabClass(key)}
        >
          {name}
        </h4>
      ))}
    </div>
  );
};

export default HistoryHeaderTabs;
